module.exports = __webpack_public_path__ + "static/media/cat.703fc5bf.svg";